import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { forgotPasswordApi } from "../../lib/utils";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");

  const { mutate, isPending } = useMutation({
    mutationFn: () => forgotPasswordApi(email),
    onSuccess: (data) => toast.success(data.message),
    onError: (err) => toast.error(err.message),
  });

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Enter your email");
    mutate();
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white border border-slate-100 rounded-2xl shadow-sm p-6 sm:p-8">
        <h1 className="text-2xl font-semibold text-slate-900">Forgot password</h1>
        <p className="text-sm text-slate-600 mt-2">
          Enter your email and we’ll send you a reset link.
        </p>

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">Email</label>
            <input
              type="email"
              className="mt-1 w-full rounded-xl border border-slate-200 px-4 py-3 outline-none focus:ring-2 focus:ring-slate-300"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
            />
          </div>

          <button
            disabled={isPending}
            className="w-full rounded-xl bg-slate-900 text-white py-3 font-medium hover:bg-slate-800 disabled:opacity-60"
          >
            {isPending ? "Sending..." : "Send reset link"}
          </button>

          <div className="flex items-center justify-between text-sm text-slate-600">
            <Link to="/login" className="hover:underline text-slate-900 font-medium">
              Back to login
            </Link>
            <Link to="/" className="hover:underline">
              Home
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
